/* NZS-GENIUS-0923: "The Genius Behind" feature template (sections/nzs-genius-article.liquid only).
   Every CTA opens the ONE on-article flavour picker (#gx-buy): desktop focuses the sticky rail, smaller
   screens focus it in place or raise it as a bottom sheet. Adds go through window.nzsATC (the shared engine
   owns retries, 422 self-heal, error toast and the drawer opening). Mobile sticky prompt stays out of the
   way of the hero, the picker, the footer and every open overlay. No document-wide MutationObserver. */
(function () {
  'use strict';
  var root = document.querySelector('[data-gx]');
  if (!root || root.__gx) return;
  root.__gx = 1;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var buy = $('[data-gx-buy]'), form = buy && $('[data-gx-form]', buy);
  var addBtn = form && $('[data-gx-add]', form), addLbl = addBtn && $('[data-gx-add-label]', addBtn);
  var priceEl = addBtn && $('[data-gx-price]', addBtn), errEl = form && $('[data-gx-err]', form);
  var statusEl = form && $('[data-gx-status]', form), pdp = buy && $('[data-gx-pdp-link]', buy);
  var closeBtn = buy && $('[data-gx-close]', buy), hero = $('[data-gx-hero]'), bar = $('[data-gx-bar]');
  var mq = function (q) { return window.matchMedia(q); };
  var mqDesk = mq('(min-width:1100px)'), mqMob = mq('(max-width:767px)'), mqCalm = mq('(prefers-reduced-motion: reduce)');
  var busy = false, sheet = false, locked = false, trigger = null, scrim = null, barReady = false;

  /* Placeholders the server transform missed (e.g. reordered attributes) get the same prompt. */
  var tpl = document.getElementById('gx-cta-tpl');
  if (tpl && tpl.content) {
    root.querySelectorAll('.gx-cta[data-gx-cta]:not(.is-ready)').forEach(function (el) {
      if (el.textContent.trim()) return; /* never clear a placeholder that holds real text */
      el.textContent = '';
      el.appendChild(tpl.content.cloneNode(true));
      el.classList.add('is-ready');
    });
  }

  function picked() { return form && form.querySelector('input[name="id"]:checked:not(:disabled)'); }
  function setErr(msg) { if (errEl) errEl.textContent = msg || ''; }
  function sync() {
    var r = picked();
    if (pdp && r) pdp.href = r.getAttribute('data-url');
    if (!addBtn) return;
    addBtn.disabled = busy || !r;
    if (priceEl) priceEl.textContent = r && r.getAttribute('data-price') ? ' · ' + r.getAttribute('data-price') : '';
  }

  /* ---------- open the picker ---------- */
  function shown(el, part) {
    var r = el.getBoundingClientRect(), h = window.innerHeight;
    var vis = Math.min(r.bottom, h) - Math.max(r.top, 0);
    return vis > 0 && vis >= Math.min(r.height, h) * part;
  }
  function focusPick() {
    var r = picked() || buy.querySelector('input[name="id"]:not(:disabled)');
    try { (r || buy).focus({ preventScroll: true }); } catch (e) { (r || buy).focus(); }
  }
  function flash() {
    buy.classList.remove('is-flash');
    void buy.offsetWidth;
    buy.classList.add('is-flash');
    clearTimeout(buy.__gxT);
    buy.__gxT = setTimeout(function () { buy.classList.remove('is-flash'); }, 900);
  }
  function expanded(v) {
    root.querySelectorAll('[data-gx-open]').forEach(function (a) { a.setAttribute('aria-expanded', v); });
  }
  function openPick(t) {
    trigger = t || null;
    if (mqDesk.matches || shown(buy, 0.6)) {
      if (!shown(buy, 0.6)) buy.scrollIntoView({ block: 'center', behavior: mqCalm.matches ? 'auto' : 'smooth' });
      focusPick();
      flash();
      return;
    }
    openSheet();
  }
  function openSheet() {
    if (sheet) return;
    sheet = true;
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'gx-scrim';
      scrim.addEventListener('click', function () { closeSheet(); });
      root.appendChild(scrim);
    }
    buy.classList.add('is-sheet');
    buy.setAttribute('role', 'dialog');
    buy.setAttribute('aria-modal', 'true');
    buy.setAttribute('aria-labelledby', 'gx-buy-title');
    if (closeBtn) closeBtn.hidden = false;
    scrim.classList.add('is-on');
    expanded('true');
    var o = window.nzsOverlay;
    if (o && o.acquireScrollLock) { o.acquireScrollLock(); locked = true; }
    focusPick();
    update();
  }
  function closeSheet(restore) {
    if (!sheet) return;
    sheet = false;
    buy.classList.remove('is-sheet');
    buy.removeAttribute('role');
    buy.removeAttribute('aria-modal');
    buy.removeAttribute('aria-labelledby');
    if (closeBtn) closeBtn.hidden = true;
    if (scrim) scrim.classList.remove('is-on');
    expanded('false');
    if (locked) { window.nzsOverlay.releaseScrollLock(); locked = false; }
    update();
    if (restore === false) return;
    var t = trigger, ok = t && t.getClientRects().length && window.getComputedStyle(t).visibility !== 'hidden';
    try { (ok ? t : buy).focus({ preventScroll: true }); } catch (e) {}
  }

  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-gx-open]');
    if (a && buy && form) { e.preventDefault(); openPick(a); return; }
    if (e.target.closest('[data-gx-close]')) closeSheet();
  });
  if (buy) buy.addEventListener('keydown', function (e) {
    if (!sheet) return;
    if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(buy.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])'), function (x) {
      return x.getClientRects().length && !(x.type === 'radio' && !x.checked && picked());
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  mqDesk.addEventListener && mqDesk.addEventListener('change', function () { if (mqDesk.matches) closeSheet(false); });

  /* ---------- add to cart ---------- */
  if (form) {
    form.addEventListener('change', function () { setErr(''); sync(); });
    /* Window capture runs BEFORE nzs-header-late.js's document-capture native-submit guard
       (document.addEventListener('submit', fn, true)), which backs off once defaultPrevented is set.
       Without this, one click = two adds. */
    window.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      e.preventDefault();
      if (busy || !addBtn) return;
      var r = picked();
      if (!r) { setErr('Choose an available flavour first.'); return; }
      busy = true;
      setErr('');
      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
      /* NZS-LOADER-0923-L9: shared 3-dot loader (1s grace) over the hidden label + price; old "Adding" text only as a fallback. */
      if (window.__nzsLoadOn) window.__nzsLoadOn(addBtn); else addLbl.textContent = 'Adding';
      var done = function (label) {
        busy = false;
        if (window.__nzsLoadOff) window.__nzsLoadOff(addBtn); /* NZS-LOADER-0923-L9 */
        addBtn.removeAttribute('aria-busy');
        addLbl.textContent = label;
        sync();
      };
      var go = function () {
        var atc = window.nzsATC;
        /* Engine missing: native POST of exactly this one unit (form.submit() fires no submit listeners).
           Stay busy + disabled: the page is navigating, and a second click must not post again. */
        if (!atc || typeof atc.add !== 'function') { form.submit(); return; }
        atc.add({ items: [{ id: Number(r.value), quantity: 1 }] }, { handle: r.getAttribute('data-handle') }).then(function () {
          done('Added');
          if (statusEl) statusEl.textContent = r.getAttribute('data-name') + ' added to cart';
          setTimeout(function () { if (!busy) addLbl.textContent = 'Add to cart'; }, 1600);
          closeSheet(false);
        }, function (err) {
          done('Add to cart');
          setErr((err && err.message) || "Couldn't add to cart. Please try again.");
        });
      };
      if (window.nzsATC || document.readyState === 'complete') go();
      else window.addEventListener('load', go, { once: true });
    }, true);
    sync();
  }

  /* ---------- mobile sticky prompt ---------- */
  if (!bar || !hero || !buy || !('IntersectionObserver' in window)) return;
  var heroIn = true, buyIn = false, footIn = false, barOn = false;
  var body = document.body, padInline = body.style.paddingBottom;
  var padBase = parseFloat(window.getComputedStyle(body).paddingBottom) || 0;
  var foot = document.querySelector('.shopify-section-group-footer-group, footer.nzf');
  function visible(el) {
    if (el === buy || el.closest('[aria-hidden="true"],[hidden]') || !el.getClientRects().length) return false;
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.opacity !== '0' && cs.pointerEvents !== 'none';
  }
  function blocked() {
    var d = document.getElementById('nzsCartDrawer'), m = document.getElementById('nzsMnav');
    if (sheet || (d && d.classList.contains('is-open')) || (m && m.classList.contains('is-open'))) return true;
    if (body.style.position === 'fixed' || body.style.overflow === 'hidden' || body.classList.contains('overflow-hidden')) return true;
    return [].some.call(document.querySelectorAll('.nzs-qa.is-in,dialog[open],[aria-modal="true"]'), visible);
  }
  function update() {
    if (!barReady) return;
    var on = mqMob.matches && !heroIn && !buyIn && !footIn && !blocked();
    if (on === barOn) return;
    barOn = on;
    bar.classList.toggle('is-on', on);
    body.style.paddingBottom = on ? (padBase + bar.offsetHeight) + 'px' : padInline;
  }
  var io = new IntersectionObserver(function (list) {
    list.forEach(function (en) {
      if (en.target === hero) heroIn = en.isIntersecting;
      else if (en.target === buy) buyIn = en.isIntersecting;
      else footIn = en.isIntersecting;
    });
    update();
  }, { rootMargin: '0px 0px 120px 0px' });
  barReady = true;
  io.observe(hero);
  io.observe(buy);
  if (foot) io.observe(foot);
  /* Narrow, attribute-only observers on the exact elements whose state we read. */
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(update);
    ['nzsCartDrawer', 'nzsMnav'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) mo.observe(el, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
    });
    mo.observe(body, { attributes: true, attributeFilter: ['style', 'class'] });
  }
  /* Quick-add, Alpine popups and native dialogs open on a click or key: re-check once they settle. */
  var later = function () { setTimeout(update, 60); setTimeout(update, 450); };
  document.addEventListener('click', later, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') later(); }, true);
  mqMob.addEventListener && mqMob.addEventListener('change', update);
})();
